// This is a wrapper for the Material UI TextField component, to prevent emoji from being entered.
// Once we upgrade the back-end database tables to UTF-8mb4 support, we can remove this file
// along with the alias in webpack.base.config.js.
//
// This TextField is now tracks Google Analytics
// if the emoji issue is resolved move the debounceTrack method to onChange event
import React from 'react';
import TextField from '@mui/material/TextField'; // eslint-disable-line no-restricted-imports
import { filterStudentInput } from '@util/text';
import { track } from '@common/analytics';
import _debounce from 'lodash/debounce';
import _uniqueId from 'lodash/uniqueId';

const DEBOUNCE_TIME = 2000;

const debounceTrack = _debounce(track, DEBOUNCE_TIME);

const FilteredTextField = ({
  onChange,
  analytics,
  error,
  helperText,
  value,
  maxLength = Infinity,
  id,
  ...props
}) => {
  const onChangeFilter = evt => {
    // eslint-disable-next-line
    evt.target.value = filterStudentInput(evt.target.value).slice(0, maxLength);
    // eslint-disable-next-line no-unused-expressions
    analytics && debounceTrack(...analytics);
    return onChange && onChange(evt);
  };

  const uniqueId = id || _uniqueId('text-field-');
  const tooLong = (value || '').length >= maxLength;

  return (
    <TextField
      {...props}
      id={uniqueId}
      error={error || tooLong}
      helperText={
        helperText ||
        (tooLong ? `You have reached the limit of ${maxLength} characters.` : null)
      }
      value={value}
      onChange={onChangeFilter}
    />
  );
};

export default FilteredTextField;
